export const environment = {
  production: true,
  usingMocks: false,
  api_url: "https://oots.simplegob.com/intermediaryapp",
  redirect_back_url: "https://oots.simplegob.com/home",
  preview_space_session: 300  //seconds
};
